import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.css']
})
export class ImageComponent implements OnInit {
  @Input() src;
  @Input() alt;
  @Input() width;
  @Input() height;
  @Input() class;
  @Input() maxWidth;

  constructor() { }

  ngOnInit() {
  }

}
